import { render, staticRenderFns } from "./loginplain.vue?vue&type=template&id=d00761e4&scoped=true&lang=html&"
import script from "./loginplain.vue?vue&type=script&lang=js&"
export * from "./loginplain.vue?vue&type=script&lang=js&"
import style0 from "./loginplain.vue?vue&type=style&index=0&id=d00761e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00761e4",
  null
  
)

export default component.exports